<template>
  <div class="container">
    <h1 class="subs-title">{{ adminText('organizationAll.package_list_86f4b676', 'Package List') }}</h1>
    <div v-if="!$apollo.loading" class="attendee_table">
      <div
        v-if="subscribers.length === 0"
        class="no-attendees-message-container border__left border__right"
      >
        <span class="no-attendees-message">{{ adminText('organizationAll.no_matching_records_found_0c7f0a64', 'No matching records found.') }}</span>
      </div>
      <table-list
        :selected.sync="selected"
        :organization-slug="organizationSlug"
        :attendees="subscribers"
        :hide-checkbox="true"
        body-style="grid-auto-columns: 50px minmax(150px, 250px) !important;"
        :visible-fields="visibleFields"
        :attendee-fields="attendeeFields"
        :pagination="pagination"
        @click="openUpdateModal = !openUpdateModal"
        @sort="handleSort($event)"
      />
      <table-pagination
        :pagination="pagination"
        :total-attendees="totalSubscribersCount"
        @change="handlePagination($event)"
        @changePerPage="handlePagination($event)"
      />
    </div>
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import { GET_ALL_ORGANIZATION_PREPAID_COUPON_USERS } from '@/graphql/prepaidCouponUser.graphql'
import { serverURL } from '@/utils'
import sumBy from 'lodash/sumBy'
import moment from 'moment'
import tableList from '../../accreditations/attendee-table/list.vue'
import tablePagination from '../../accreditations/attendee-table/pagination.vue'

export default {
  mixins: [OrganizationLocalization],
  name: 'subscriptions-list',
  components: {
    tableList,
    tablePagination,
  },
  props: {
    organizationSlug: {
      type: String,
    },
  },
  data() {
    const { pagination } = this.getInitialFromQueryParams()

    return {
      serverURL,
      subscribers: [],
      pagination,
      token: undefined,
      showDeleteDialog: false,
      openCreateModal: false,
      openUpdateModal: false,
      selected: [],
      organizerId: null,
      attendeeFields: {},
      visibleFields: ['Name', 'Package Plan', 'Created', 'Expires', 'Package status'],
      totalSubscribersCount: 0,
    }
  },
  async mounted() {
    await this.fetchSubscribers()
  },
  methods: {
    calculateSubscriptionStatus(redeemedCouponItems, couponItems) {
      const totalAvailableTickets = couponItems.length ? sumBy(couponItems, 'ticketAmount') : 0

      return `${redeemedCouponItems.length || '0'}/${totalAvailableTickets}`
    },
    async handlePagination({ page, per_page }) {
      const { page: currentPage, per_page: currentPerPage } = this.pagination
      if (currentPage > page && currentPage === 1) return
      if (page > currentPage && !(this.totalSubscribersCount - currentPerPage * currentPage > 0))
        return

      this.pagination = {
        ...this.pagination,
        per_page: per_page === 'All' ? -1 : per_page,
        page: page,
      }

      await this.addPaginationToRoute(this.pagination)
    },
    async handleSort(sortBy) {
      const { per_page, page, sortBy: thisSortBy, descending } = this.pagination
      const pagination = {
        page,
        per_page,
        sortBy,
        descending: sortBy === thisSortBy ? !descending : false,
      }
      await this.addPaginationToRoute(pagination)
      this.pagination = pagination
    },
    getInitialFromQueryParams() {
      const { per_page, page, sortBy, descending } = this.$route.query

      return {
        pagination: {
          page: parseInt(page, 10) || 1,
          per_page: parseInt(per_page, 10) || 10,
          sortBy: sortBy,
          descending: descending ? !!descending : false,
        },
      }
    },
    async addPaginationToRoute({ page, per_page, sortBy, descending }) {
      await this.$router.replace({
        query: {
          ...this.$route.query,
          per_page,
          page,
          sortBy,
          descending: descending ? 1 : 0,
        },
      })

      await this.fetchSubscribers()
    },
    async fetchSubscribers() {
      const {
        data: { getAllPrepaidCouponUsers },
        errors,
      } = await this.$apollo.query({
        query: GET_ALL_ORGANIZATION_PREPAID_COUPON_USERS,
        variables: {
          organizationSlug: this.organizationSlug,
        },
      })

      if (errors) {
        this.snackbar = {
          open: true,
          messageProp: 'Oops, Something went wrong!',
          color: 'error',
        }
      } else {
        this.totalSubscribersCount = getAllPrepaidCouponUsers.length

        this.subscribers =
          getAllPrepaidCouponUsers.map(e => {
            return {
              id: e.id,
              name: e.name,
              'package plan': e.prepaidCoupon.name,
              created: moment(e.createdAt).format('DD.MM.YYYY'),
              expires: moment(e.prepaidCoupon.to).format('DD.MM.YYYY'),
              email: e.email,
              'package status': this.calculateSubscriptionStatus(
                e.redeemedCouponItems,
                e.prepaidCoupon.couponItems,
              ),
            }
          }) || {}
      }
    },
  },
}
</script>

<style scoped>
.page-description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  color: #979797;
}
.container {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  max-width: 100%;
}
.subs-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
</style>
